import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Code, ConnectError } from '@connectrpc/connect';
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { usePortfolioEconomics } from '../hooks/usePortfolioEconomics';
import { EconomicsFigures } from './EconomicsFigures';
/** This Landscape's row of the single GetPortfolioEconomics response. */ export function LandscapeEconomicsPanel({ landscapeId }) {
    const { data, isLoading, error, refetch } = usePortfolioEconomics([
        landscapeId
    ]);
    const row = data?.landscapes.find((l)=>l.landscapeId === landscapeId);
    return /*#__PURE__*/ _jsxs("section", {
        className: "rounded-md border border-border p-3",
        "data-testid": Testids.portfolio.detail,
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "mb-2 text-sm font-medium",
                children: "Economics"
            }),
            isLoading && /*#__PURE__*/ _jsx("p", {
                className: "text-sm text-muted-foreground",
                children: "Loading…"
            }),
            error && /*#__PURE__*/ _jsxs("div", {
                role: "alert",
                "data-testid": Testids.portfolio.unavailable,
                children: [
                    error instanceof ConnectError && error.code === Code.PermissionDenied ? 'You do not have permission to view economics.' : 'Economics could not be loaded.',
                    /*#__PURE__*/ _jsx(SpecraButton, {
                        onClick: ()=>refetch(),
                        children: "Retry economics"
                    })
                ]
            }),
            !isLoading && !error && !row?.figures && /*#__PURE__*/ _jsx("p", {
                children: "No economics available for this Landscape."
            }),
            row?.figures && /*#__PURE__*/ _jsx(EconomicsFigures, {
                figures: row.figures
            })
        ]
    });
}
